<template>
<div>
  <div class="row">
    <div class="col-xl-4 m-t">
         <subscription-box v-if="me && me.subscription" :subscription="me.subscription" fixed bordered caption="<i class='fa fa-money'></i> Assinatura"></subscription-box>
    </div>
    <div class="col-xl-8 m-t">
      <div class="card bg-info">
        <div class="card-body pb-0">
          <div class="text-value text-center text-white">Escolha um plano</div>
        </div>
        <b-row>
          <b-col sm="6" class="col-sm-offset-3" offset-sm="3">
            <div class="card-body pb-0">
              <b-form>
                <b-input-group class="mb-3">
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Cupom de desconto"
                    @keyup.enter.native="$refs.surname.$el.focus()"
                    v-model="coupon"
                    autocomplete="name"
                  />
                  <b-input-group-append>
                    <b-button variant="primary" @click="validateDiscountCoupon()" :disabled="!coupon" type="button" style="margin-bottom: 4px">
                      <span>Validar</span>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <p v-if="couponValidated">Cupom validado!</p>
                <p v-if="couponFailed">Não foi possível validar o cupom</p>
              </b-form>
            </div>
          </b-col>
        </b-row>
        <b-row class="m-t padder">
          <b-col md="3" v-for="plan in plans" v-bind:key="plan._id" @click="selectPlan(plan)">
            <div class="card" v-bind:class="{ 'bg-dark': plan._id == currentPlanId }">
              <div class="card-body text-center">
                <div class="text-value text-center text-black" v-bind:class="{ 'text-white': plan._id == currentPlanId }">R${{plan.priceInteger}},{{plan.priceDecimal}}</div>
                <small class="text-muted text-uppercase font-weight-bold text-center" v-bind:class="{ 'text-white': plan._id == currentPlanId }">{{plan.label}}</small>
                <br />
                <h3 class="text-black" v-bind:class="{ 'text-white': plan._id == currentPlanId }">
                  <i class="fa fa-shopping-cart"></i>
                </h3>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row style="justify-content: center; margin-bottom: 10px;" v-if="currentPlanRecurrent">
          <!-- <b-button-group>
            <b-button @click="() => { pagseguroRecurrent = true; pagseguroNoCreditCard = false }" v-bind:variant="pagseguroRecurrent? 'success' : 'info'">Cartão</b-button>
            <b-button @click="() => { pagseguroRecurrent = false; pagseguroNoCreditCard = true }" v-bind:variant="pagseguroNoCreditCard? 'success' : 'info'">Outros</b-button>
          
          
          </b-button-group> -->
   <b-form-group>
      <b-form-radio-group
        v-model="paymentMethod"
        :options="options"
        name="radio-inline"
      ></b-form-radio-group>
    </b-form-group>
        </b-row>
        <b-row v-else>
          <br><br>
          </b-row>
        <b-row style="justify-content: center">
          <b-button variant="success" @click="subscribePagseguro()" :disabled="!currentPlanId || paying || (currentPlanRecurrent && paymentMethod < 1)" type="button" style="margin-bottom: 4px">
            <span>Comprar</span>
          </b-button>
        </b-row>
        <br />
      </div>
    </div>
    </div>
        <b-row class="m-t">
  <b-col md="12">
      </b-col>
  </b-row>
  <router-view></router-view>
  </div>
   


 
</template>

<script>
import PaymentHistory from "./PaymentHistory";
import SubscriptionBox from "./SubscriptionBox";
import service from "../service";

export default {
  name: "PaymentsPage",
  data() {
    return {
      selected: [], // Must be an array reference!
      show: true,
      plans: [],
      currentPlanId: undefined,
      currentPlanRecurrent: false,
      me: {},
      paying: false,
      pagseguroNormal: false,
      pagseguroRecurrent: false,
      pagseguroNoCreditCard: false,
      paymentMethod: 0,
      coupon: "",
      couponValidated: false,
      couponFailed: false,
      options: [
          { text: 'Cartão de Crédito', value: 1 },
          { text: 'Boleto e outros', value: 2 }
        ]
    };
  },
  methods: {
    click() {
      // do nothing
    },
    getMe: function() {
      service.getMe().then(user => {
        this.me = user;
      });
    },
    subscribePagseguro () {
      this.paying = true;
      let method = "pagseguro-normal"
      if (this.paymentMethod == 1) {
        method = "pagseguro-recurrent";
      } else if (this.paymentMethod == 2) {
        method = "pagseguro-no-credit-card";
      }

      let pagseguroCoupon = undefined;

      if (this.couponValidated) {
        pagseguroCoupon = this.coupon;
      }

      service.subscribePagseguro(this.currentPlanId, method, pagseguroCoupon).then(result => {
        this.paying = false;
        if (result && result.paymentURL) {
          localStorage.paymentURL = result.paymentURL;
          this.$router.push("/payments/load");
        }
      }).catch(error => {
        this.paying = false;
        if(error && error.message) {
          this.errorMessage = error.message;
        }
      });
    },
    getPlans: function(coupon) {
      service.getPlans(coupon).then(result => {
        this.plans = result.plans;

        if (result.discountedPrices) {
          this.couponValidated = true;
          this.couponFailed = false;
        } else if (coupon) {
          this.couponValidated = false;
          this.couponFailed = true;
        }
      }).catch(() => {
        this.couponFailed = true;
        this.couponValidated = false;
      });
    },
    validateDiscountCoupon() {
      this.getPlans(this.coupon);
    },
    selectPlan(selectedPlan) {
        this.currentPlanId = selectedPlan._id;
        this.currentPlanRecurrent = selectedPlan.recurrent;

        if (!this.currentPlanRecurrent) {
          this.pagseguroNormal = true;
          this.pagseguroRecurrent = false;
          this.pagseguroNoCreditCard = false;
        }
    }
  },
  created() {
    this.getMe();
    this.getPlans();
    this.$on("UPDATE_ME_PAYMENTS", function() {
      this.me = {};
      this.getMe();
      this.$parent.$emit("UPDATE_ME");
    });
  },
  components: { SubscriptionBox }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.m-t {
  margin-top: 20px !important;
}

.padder {
  padding: 40px !important;
}

.text-black {
  color: black !important;
}

.text-white {
  color: white !important;
}
</style>


